import * as React from 'react';
import * as cn from 'classnames';

import './Toggler.scss';

interface Props {
    onToggle: () => void;
    isOpened: boolean;
    isDisabled?: boolean;
    onText?: string;
    offText?: string;
}

const Toggler: React.FC<Props> = props => {
    const { isOpened, isDisabled, onText, offText } = props;

    const styles = cn('container', {
        'is-open': isOpened,
        'is-disabled': isDisabled,
    });

    const classes = cn('__app-Toggler-container', {
        '__app-Toggler-is-open': isOpened,
        '__app-Toggler-is-disabled': isDisabled,
    });

    return (
        <div styleName={styles} className={classes} onClick={props.onToggle}>
            {onText && (
                <div styleName="label on" className="__app-Toggler-label-on">
                    {onText}
                </div>
            )}
            <div styleName="thumb" className="__app-Toggler-thumb" />
            {offText && (
                <div styleName="label off" className="__app-Toggler-label-off">
                    {offText}
                </div>
            )}
        </div>
    );
};

export default Toggler;
